'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerFormat = exports.config = undefined;
exports.discover = discover;
exports.fromXml = fromXml;
exports.deserialize = deserialize;

var _service = require('./service');

var _config = require('./config');

var _formats = require('./formats');

/**
 * @module opensearch
 */

/**
 * Accesses an OpenSearch service and discovers it.
 * @param {object} url The URL to find the OpenSearchDescription XML document
 * @returns {Promise<OpenSearchService>} The {@link OpenSearchService} as a Promise
 */
function discover(url) {
  return _service.OpenSearchService.discover(url);
}

/**
 * Creates a new {@link OpenSearchService} from the given XML string containing
 *                                         the OpenSearch description document.
 * @param {string} xml The XML string containing the OpenSearch description document.
 * @returns {OpenSearchService} The {@link OpenSearchService}
 */
function fromXml(xml) {
  return _service.OpenSearchService.fromXml(xml);
}

/**
 * Deserialize a previously serialized {@link OpenSearchService}.
 * @param {object} values The serialized service description
 * @returns {OpenSearchService} The deserialized service
 */
function deserialize(values) {
  return _service.OpenSearchService.deserialize(values);
}

exports.config = _config.config;
exports.registerFormat = _formats.registerFormat;


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/index.js